var _path, _path2, _ellipse, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5197 15C30.5197 23.1458 23.9049 29.75 15.7442 29.75C7.58355 29.75 0.96875 23.1458 0.96875 15C0.96875 6.8542 7.58355 0.25 15.7442 0.25C23.9049 0.25 30.5197 6.8542 30.5197 15Z",
    fill: "url(#paint0_linear_9500_1308)",
    stroke: "url(#paint1_linear_9500_1308)",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.851 20.6039C21.2209 20.527 21.4412 20.1398 21.2569 19.81C20.8525 19.0858 20.2158 18.4494 19.4017 17.9644C18.352 17.339 17.0659 17 15.7429 17C14.4198 17 13.1338 17.339 12.0841 17.9643C11.27 18.4494 10.6333 19.0858 10.2289 19.81C10.0446 20.1398 10.2649 20.527 10.6348 20.6039C14.0041 21.3049 17.4817 21.3049 20.851 20.6039Z",
    fill: "url(#paint2_linear_9500_1308)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.7452,
    cy: 12.3333,
    rx: 3.33899,
    ry: 3.33333,
    fill: "url(#paint3_linear_9500_1308)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9500_1308",
    x1: 14.4233,
    y1: 0,
    x2: 14.4233,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0208333,
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453724,
    stopColor: "#2E2A2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9500_1308",
    x1: 4.21808,
    y1: 3.51878,
    x2: 27.2132,
    y2: 26.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C6034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1432,
    stopColor: "#A9824F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4583,
    stopColor: "#F2D893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5112,
    stopColor: "#FFE79F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6912,
    stopColor: "#D7B674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96662E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9500_1308",
    x1: 11.2895,
    y1: 17.5474,
    x2: 13.765,
    y2: 23.7065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C6034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1432,
    stopColor: "#A9824F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4583,
    stopColor: "#F2D893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5112,
    stopColor: "#FFE79F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6912,
    stopColor: "#D7B674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96662E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9500_1308",
    x1: 13.1839,
    y1: 9.78195,
    x2: 18.2939,
    y2: 14.9007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C6034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1432,
    stopColor: "#A9824F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4583,
    stopColor: "#F2D893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5112,
    stopColor: "#FFE79F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6912,
    stopColor: "#D7B674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96662E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.d4172e2005ebf77e94f42aa4d7623ab7.svg";
export { ForwardRef as ReactComponent };